"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var moment = require('moment');

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var uniq = require('lodash/uniq');

var flatten = require('lodash/flatten');

var ShineProducts = require('../products/ShineProducts');

var _require2 = require('../products/constants'),
    WEDDING_POSTPONEMENT_ANNOUNCEMENTS = _require2.WEDDING_POSTPONEMENT_ANNOUNCEMENTS;

var OrderNote = require('../orders/classes/OrderNote');

var _require3 = require('../products/interfaces'),
    Envelope = _require3.Envelope;
/**
 * @class
 * @param {String} params.id
 * @param {String} params.order_id
 * @param {String} params.shipment_id
 * @param {String} params.print_job_email_id
 * @param {String} params.printer_name
 * @param {String} params.designation
 * @param {String} params.printing_type
 * @param {String} params.status
 * @param {Boolean} params.archived
 * @param {String} params.designer_id
 * @param {String} params.sender_id
 * @param {String} params.origin
 * @param {String} params.name - job name (e.g. 'Smith, Joe')
 * @param {Date} params.approved_on_date
 * @param {Date} params.date_created
 * @param {Date} params.print_by_date
 * @param {Date} params.date_completed
 * @param {Boolean} params.reprint - read only, equal to is_reprint
 * @param {Boolean} params.is_reprint
 * @param {Boolean} params.is_test_print
 * @param {String} params.reprint_reason
 * @param {Array<Product>} products
 */
// const statuses = ['received', 'processed', 'printed', 'cut', 'scored_folded', 'finished', 'delivered'];


var PrintJob = /*#__PURE__*/function () {
  function PrintJob() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PrintJob);

    this.id = params.id;
    this.order_id = params.order_id;
    this.shipment_id = params.shipment_id || null;
    this.print_job_email_id = params.print_job_email_id || null;
    this.printer_name = params.printer_name;
    this.designation = params.designation || null;
    this.printing_type = params.printing_type || null;
    this.status = params.status || 'proofing';
    this.archived = parseBoolean(params.archived);
    this.approved_on_date = params.approved_on_date ? moment(params.approved_on_date) : null;
    this.date_created = params.date_created ? moment(params.date_created) : moment();
    this.print_by_date = params.print_by_date ? moment(params.print_by_date) : null;
    this.products = params.products ? params.products.map(function (prod) {
      return ShineProducts.instance().make(prod);
    }) : [];
    this.date_completed = params.date_completed ? moment(params.date_completed) : null;
    this.designer_id = params.designer_id || null;
    this.sender_id = params.sender_id || params.designer_id || null;
    this.name = params.name || 'No Name';
    this.origin = params.origin || null;
    this.notes = params.notes && Array.isArray(params.notes) ? params.notes.map(function (note) {
      return new OrderNote(note);
    }) : [];
    this.reprint_reason = params.reprint_reason || null;
    this.is_reprint = parseBoolean(params.is_reprint);
    this.is_test_print = parseBoolean(params.is_test_print);
    this.match_color = parseBoolean(params.match_color);
  }

  _createClass(PrintJob, [{
    key: "has_envelopes",
    get: function get() {
      return this.products.some(function (product) {
        return product.subcomponents().some(function (subcomponent) {
          return subcomponent instanceof Envelope;
        });
      });
    }
  }, {
    key: "collectAttributeFromProducts",
    value: function collectAttributeFromProducts(attr) {
      var attributes = [];
      this.products.forEach(function (prod) {
        if (Array.isArray(prod[attr])) {
          attributes.concat(prod[attr]);
        }

        if (prod[attr]) {
          attributes.push(prod[attr]);
        }
      });
      return uniq(flatten(attributes));
    }
  }, {
    key: "reprint",
    get: function get() {
      return this.is_reprint;
    }
  }, {
    key: "print_job_id",
    get: function get() {
      return this.id;
    },
    set: function set(id) {
      this.id = id;
    }
  }, {
    key: "printingDetails",
    get: function get() {
      return this.components;
    },
    set: function set(arr) {
      if (Array.isArray(arr)) {
        this.components = arr;
      } else {
        throw new Error('printingDetails must be an array');
      }
    }
  }, {
    key: "customer_name",
    get: function get() {
      return this.name;
    }
  }, {
    key: "is_for_covid",
    get: function get() {
      return this.products.some(function (prod) {
        return prod.product_type.match(/covid/i) || prod.product_type === WEDDING_POSTPONEMENT_ANNOUNCEMENTS;
      });
    }
  }, {
    key: "email",
    get: function get() {
      return this.EMAIL_ADDRESSES[this.printer_name];
    }
  }]);

  return PrintJob;
}();

module.exports = PrintJob;